export default "__VITE_ASSET__zm0B5VuD__"